/* eslint-disable import/prefer-default-export */
import React from 'react';
import { SkeletonNew } from './SkeletonNew';
import GameThumbnailList, { SectionWrapper } from '../GameThumbnailList';
import { providerFilter, searchFilter } from './FilteredGames';
import useQuery from '../../../hooks/useQuery';
import useActiveGames from '../../../hooks/games/useActiveGames';
import { useGetPeopleArePlayingGames } from '../../../hooks/games/useGetPeopleArePlayingGames';

export const PeopleArePlayingGames = () => {
  const { games, state, response } = useGetPeopleArePlayingGames();
  const { query } = useQuery();
  const searchText = query.get('search');
  const { activeProvider } = useActiveGames();

  const text = response?.because_you_played_context?.[0]?.name ? `Because You Played ${response?.because_you_played_context?.[0]?.name}` : 'People Are Playing';

  if (state === 'error') {
    return null;
  }

  if (state === 'loading') {
    return (
      <SectionWrapper>
        <h2 className="is-size-4 has-text-weight-bold has-text-primary container has-text-centered">
          {text}
        </h2>
        <div
          id="game-grid"
          className="m-game-grid columns is-multiline is-mobile parent-grid skeleton"
        >
          {new Array(6).fill(true).map((_, i) => (
            <SkeletonNew key={i} />
          ))}
        </div>
      </SectionWrapper>
    );
  }

  const filteredGames = games
    ?.filter((game) => searchFilter(game, searchText))
    ?.filter((game) => providerFilter(game, activeProvider?.id, 'provider'));

  const filteredCategory = {
    id: 999997,
    slug: 'people-are-playing',
    name: 'People Are Playing',
    displayGamesCount: 12,
    display_name: text,
    moreGamesToDisplay: 0,
    position: 0,
    showWinnersList: false,
    isMobile: false,
    loadAllGames: true,
    games: filteredGames?.map((game) => ({
      ...game,
      mega_thumb: false,
      vertical_thumbnail: {},
    })),
    count: filteredGames?.length,
    totalCount: filteredGames?.length,
  };

  return (
    <GameThumbnailList
      category={filteredCategory}
      maxLimit={filteredCategory?.displayGamesCount}
    />
  );
};
